
  <template><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#64748b" d="M11.598 3.432a1.98 1.98 0 0 1 2.739 0v.004a1.9 1.9 0 0 1 .002 2.734L7.81 12.565l-.004.004a1.977 1.977 0 0 1-2.722.015l-.001.002-3.4-3.134-.018-.017a1.9 1.9 0 0 1 0-2.74 1.98 1.98 0 0 1 2.717-.022L6.41 8.516l5.182-5.079zm2.044.72a.98.98 0 0 0-1.35 0l-5.856 5.74-2.726-2.48a.98.98 0 0 0-1.35 0 .9.9 0 0 0 0 1.304l3.4 3.133a.98.98 0 0 0 1.351 0l6.53-6.393a.9.9 0 0 0 0-1.303z"/></svg></template>
  <style scoped>
    svg {
      display: inline-block;
      vertical-align: baseline;
      margin-bottom: -2px;
    }
  </style>